import { IState } from '../state/state';
import { createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromSiteRequest from './site-request.adapter';
import * as fromSiteApprovals from './site-approvals.adapter';
import { appSelector } from '../state/state.selector';


export const siteRedinessMatrixSelector = (state: IState) => state.appData.siteRedinessMatrix;
export const approvedRequestDetailsSelector = (state: IState) => state.appData.approvedRequestData;


export const SiteRequestsState = createFeatureSelector<fromSiteRequest.SiteRequestRequestsState>('siteRequests');
export const SiteRequestApprovalsState = createFeatureSelector<fromSiteApprovals.SiteRequestApprovalsState>('siteApprovals');

export const SiteRequestsSelector = createSelector(SiteRequestsState, fromSiteRequest.selectAllSiteRequestsEntities);
export const SiteRequestsIsLoadedSelector = createSelector(SiteRequestsState, fromSiteRequest.getSiteRequestsIsLoaded);
export const SelectCurrentSiteRequestId = createSelector(SiteRequestsState, fromSiteRequest.getSiteRequestsSelectedId);
export const SiteRequestEntities = createSelector(SiteRequestsState, fromSiteRequest.selectSiteRequestsEntities);
export const SelectCurrentSiteRequest = createSelector(SiteRequestEntities, SelectCurrentSiteRequestId, (entities, id) => entities[id]);


export const SiteRequestApprovalsSelector = createSelector(SiteRequestApprovalsState, fromSiteApprovals.selectAllSiteRequestApprovalsEntities);
export const SiteRequestApprovalsIsLoadedSelector = createSelector(SiteRequestApprovalsState, fromSiteApprovals.getSiteApprovalsIsLoaded);
export const SiteRequestApprovalsEntities = createSelector(SiteRequestApprovalsState, fromSiteApprovals.selectSiteRequestApprovalsEntities);
export const SelectCurrentSiteApprovalId = createSelector(SiteRequestApprovalsState, fromSiteApprovals.getSiteApprovalsSelectedId);
export const SelectCurrentSiteApproval = createSelector(SiteRequestApprovalsEntities, SelectCurrentSiteApprovalId, (entities, id) => entities[id]);

export const proxyRequestMembersSelector = createSelector(appSelector, (state) => state.proxyRequestMembers);

export const siteRequestProxyDetailsSelector = createSelector(appSelector, (state) => state.siteRequestProxyDetails);

